// extracted by mini-css-extract-plugin
export default {"record-writebox":"BodyMassWrite_record-writebox__rawrS","date-record":"BodyMassWrite_date-record__RIEkf","time-record":"BodyMassWrite_time-record__5uuuW"};